<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['activities.index'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'REPORTS.ACTIVITY_LIST.TITLE' | translate }}</h5>
    </div>
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>
    </div>
  </div>

  <kendo-grid
    [data]="data"
    [pageSize]="commentsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Activity', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'REPORTS.ACTIVITY_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'REPORTS.ACTIVITY_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      [width]="200"
      field="user.fake_first_name"
      title="{{ 'REPORTS.ACTIVITY_LIST.USER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('user.fake_first_name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-user-select [filter]="filter" [field]="'user_id'"></app-kendo-user-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.user?.names }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="100"
      field="commentable_type"
      title="{{ 'REPORTS.ACTIVITY_LIST.COMMENTABLE_TYPE' | translate }}"
      [hidden]="isHiddenColumn('commentable_type')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.cleanCommentableType }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [width]="300"
      field="about"
      title="{{ 'REPORTS.ACTIVITY_LIST.ABOUT' | translate }}"
      [hidden]="isHiddenColumn('about')"
      [filterable]="false"
      [sortable]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.about }}
        <app-comment-view-button [comment]="dataItem"></app-comment-view-button>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="type_id" title="Type" [hidden]="isHiddenColumn('type')" [filterable]="true">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-types-select [groupType]="'comment'" [filter]="filter" [field]="'type_id'"></app-kendo-types-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.type"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="comment"
      title="{{ 'REPORTS.ACTIVITY_LIST.COMMENT' | translate }}"
      [hidden]="isHiddenColumn('comment')"
      filter="text"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.comment }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      width="140"
      field="created_at"
      title="{{ 'REPORTS.ACTIVITY_LIST.DATE' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('created_at')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.created_at.getDateTime() }}
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
